__turbopack_context__.v({
  "badge": "_13lBSG_badge",
  "card": "_13lBSG_card",
  "change": "_13lBSG_change",
  "check": "_13lBSG_check",
  "isLoading": "_13lBSG_isLoading",
  "loadingDots": "_13lBSG_loadingDots",
  "location": "_13lBSG_location",
  "metaLine": "_13lBSG_metaLine",
  "pincodeForm": "_13lBSG_pincodeForm",
  "pincodeInput": "_13lBSG_pincodeInput",
  "resultPill": "_13lBSG_resultPill",
  "sddDotPulse": "_13lBSG_sddDotPulse",
  "sddShimmerSweep": "_13lBSG_sddShimmerSweep",
  "shimmerTitle": "_13lBSG_shimmerTitle",
  "slot": "_13lBSG_slot",
  "timelineLabel": "_13lBSG_timelineLabel",
  "timerDigits": "_13lBSG_timerDigits",
  "title": "_13lBSG_title",
  "titleRow": "_13lBSG_titleRow",
});
